import classNames from 'classnames'
import * as React from 'react'

import styles from './BusyAgentsCounter.css'

type Props = {
  busyCount: number
  disconnectedCount: number
  count: number
  className?: string
}
export default function BusyAgentsCounter({
  busyCount,
  disconnectedCount,
  count,
  className = '',
}: Props) {
  const connectedCount = count - disconnectedCount
  return (
    <span className={classNames(styles.agentsCounter, className)}>
      {busyCount > 0 ? (
        <span className={styles.busyAgentsCounter} data-test-busy-agents-counter={'count'}>
          {busyCount}
        </span>
      ) : null}
      {busyCount > 0 && busyCount < connectedCount ? '/' : null}
      {busyCount < connectedCount ? connectedCount : null}
    </span>
  )
}
